






import Vue from "vue";
import Component from "vue-class-component";

@Component({
  props: {
    error: Boolean
  }
})
export default class FramedBox extends Vue {}
